import { AxiosError } from "axios";

import * as types from "../Types/NotificationActionTypes";
import { INotification } from "../Models/Notification";
import { IUpdateNotificationRequest } from "../Models/Requests/Notifications/UpdateNotificationRequest";

/** misc */
export const setLoadingNotifications = (loading: boolean): types.SetLoadingNotificationsAction => ({
    type: types.SET_LOADING_NOTIFICATIONS,
    data: loading
});

export const setNotificationsDrawerVisible = (visible: boolean): types.SetNotificationsDrawerVisible => ({
    type: types.SET_NOTIFICATIONS_DRAWER_VISIBLE,
    data: visible
});

export const setNotificationsFilterDates = (dates: [Date, Date]): types.SetNotificationFilterDates => ({
    type: types.SET_NOTIFICATION_FILTER_DATES,
    data: dates
});

/** initiate */
export const getNotificationsInitiate = (range: [Date, Date]): types.GetNotificationsInitiate => ({
    type: types.GET_NOTIFICATIONS_INITIATE,
    data: range
});

export const setNotificationsByLinkIdViewedInitiate = (linkId: string): types.SetNotificationsByLinkIdViewedInitiate => ({
    type: types.SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_INITIATE,
    data: linkId
});

export const updateNotificationInitiate = (request: IUpdateNotificationRequest): types.UpdateNotificationInitiate => ({
    type: types.UPDATE_NOTIFICATION_INITIATE,
    data: request
});

export const updateAllNotificationsReadStatusInitiate = (allRead: boolean): types.UpdateAllNotificationsReadStatusInitiate => ({
    type: types.UPDATE_ALL_NOTIFICATIONS_READ_STATUS_INITIATE,
    data: allRead
});

export const updateAllNotificationsActiveStatusInitiate = (allActive: boolean): types.UpdateAllNotificationsActiveStatusInitiate => ({
    type: types.UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_INITIATE,
    data: allActive
});
/** success */
export const setNotificationsByLinkIdViewedSuccess = (linkId: string): types.SetNotificationsByLinkIdViewedSuccess => ({
    type: types.SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_SUCCESS,
    data: linkId
});

export const getNotificationsSuccess = (notifications: INotification[]): types.GetNotificationsSuccess => ({
    type: types.GET_NOTIFICATIONS_SUCCESS,
    data: notifications
});

export const updateNotificationSuccess = (notification: INotification): types.UpdateNotificationSuccess => ({
    type: types.UPDATE_NOTIFICATION_SUCCESS,
    data: notification
});

export const updateAllNotificationsReadStatusSuccess = (allRead: boolean): types.UpdateAllNotificationsReadStatusSuccess => ({
    type: types.UPDATE_ALL_NOTIFICATIONS_READ_STATUS_SUCCESS,
    data: allRead
});

export const updateAllNotificationsActiveStatusSuccess = (allActive: boolean): types.UpdateAllNotificationsActiveStatusSuccess => ({
    type: types.UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_SUCCESS,
    data: allActive
});
/** failure */
export const setNotificationsByLinkIdViewedFailure = (errMsg: string): types.SetNotificationsByLinkIdViewedFailure => ({
    type: types.SET_NOTIFICATIONS_BY_LINK_ID_VIEWED_FAILURE,
    data: errMsg
});

export const getNotificationsFailure = (errMsg: string): types.GetNotificationsFailure => ({
    type: types.GET_NOTIFICATIONS_FAILURE,
    data: errMsg
});

export const updateNotificationFailure = (errMsg: string): types.UpdateNotificationFailure => ({
    type: types.UPDATE_NOTIFICATION_FAILURE,
    data: errMsg
});

export const updateAllNotificationsReadStatusFailure = (errMsg: string): types.UpdateAllNotificationsReadStatusFailure => ({
    type: types.UPDATE_ALL_NOTIFICATIONS_READ_STATUS_FAILURE,
    data: errMsg
});

export const updateAllNotificationsActiveStatusFailure = (errMsg: string): types.UpdateAllNotificationsActiveStatusFailure => ({
    type: types.UPDATE_ALL_NOTIFICATIONS_ACTIVE_STATUS_FAILURE,
    data: errMsg
});
